/* eslint-disable camelcase */
import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { TextField, Chip } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import moment from 'moment';

import NewPatientModal from '../NewPatientModal';
import { getPatients } from '../../store/actions/patients';

const useStyles = makeStyles(() => ({
  info: {
    fontSize: 14,
    fontWeight: 'normal',
    margin: 0,
  },
  patientOptions: {
    display: 'flex',
  },
  title: {
    fontSize: 12,
    color: '#1e3f9e',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  button: {
    margin: '1rem 0 2rem 2rem',
    color: 'white',
    backgroundColor: '#00d1b2',
    '&:hover': {
      backgroundColor: '#00bca0',
    },
  },
  dropdown: {
    marginTop: '-2.5rem',
    width: 300,
  },
  chip: {
    marginTop: '-1rem',
    marginLeft: '2em',
  },
}));

const Patient = ({ setPatient, patient, device }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [isNewPatientModalOpen, setIsNewPatientModalOpen] = useState(false);
  const patientsList = useSelector((state) => state.patients.patientsList);
  const [filteredPatientsList, setFilteredPatientsList] = useState([]);
  const [patientValues, setPatientValues] = useState(null);
  const query = new URLSearchParams(useLocation().search);
  const id = query.get('patient');

  useEffect(() => {
    dispatch(getPatients(true, -1, -1));
  }, []);

  useEffect(() => {
    if (!isNewPatientModalOpen) dispatch(getPatients());
  }, [isNewPatientModalOpen]);

  useEffect(() => {
    setFilteredPatientsList(patientsList.filter((checkPatient) => !checkPatient.device_a || !checkPatient.device_b));
    if (id) {
      const match = filteredPatientsList.find((findPatient) => findPatient.id.toString() === id);
      setPatient(match);
    }
    if (patientValues) {
      const match = filteredPatientsList.find((findPatient) => {
        if (
          findPatient.first_name === patientValues.first_name &&
          findPatient.last_name === patientValues.last_name &&
          findPatient.dob === patientValues.dob
        ) {
          return true;
        }
        return false;
      });
      if (match) {
        setPatient(match);
        setPatientValues(null);
      }
    }
  }, [patientsList]);

  const onPatientChosen = (event, newValue) => {
    setPatient(newValue);
  };

  const handleDelete = () => {
    setPatient(null);
  };
  
  const getLabel = useCallback((labelPatient) => {
    var formattedDate = "";
    if (labelPatient.dob) {
      const date = new Date(labelPatient.dob);
      formattedDate = `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
    }
    return `${labelPatient.first_name} ${labelPatient.last_name} ${formattedDate}`;
  }, []);
  

  return (
    <div className={classes.root}>
      <NewPatientModal open={isNewPatientModalOpen} setOpen={setIsNewPatientModalOpen} setPatient={setPatientValues} />
      <h5 className={classes.info}>
        <span>Monitor ID: </span>
        <b>{device ? device.mac_address : ''}</b>
      </h5>
      <h4 className={classes.title}>Search for a Patient and verify their information, or add a new Patient:</h4>
      <div className={classes.patientOptions}>
        <div className={classes.container}>
          <Autocomplete
            options={filteredPatientsList}
            className={classes.dropdown}
            getOptionLabel={(option) => getLabel(option)}
            id="auto-complete"
            autoComplete
            value={patient}
            onChange={(event, newValue) => onPatientChosen(event, newValue)}
            renderInput={(params) => <TextField {...params} label="Patient" margin="normal" />}
          />
          {patient && (
            <Chip className={classes.chip} label={getLabel(patient)} onDelete={handleDelete} color="primary" />
          )}
        </div>
        <Button className={classes.button} variant="contained" onClick={() => setIsNewPatientModalOpen(true)}>
          Add New Patient
        </Button>
      </div>
    </div>
  );
};

Patient.propTypes = {
  setPatient: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  patient: PropTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  device: PropTypes.any,
};

Patient.defaultProps = {
  setPatient: null,
  patient: null,
  device: null,
};

export default Patient;
